import type React from 'react';

import { TranslateHtml } from '@change-corgi/core-react/i18n';
import { Text } from '@change-corgi/design-system-legacy/typography';

export const Header: React.FC = () => {
	return (
		<Text as="div">
			{/* TODO: replace links using <Link>? */}
			<TranslateHtml
				value="fe.components.petition_report_abuse.form_description"
				replacements={{ tosUrl: '/policies/terms-of-service', cgUrl: '/policies/community' }}
			/>
		</Text>
	);
};
